import { ACTION_TYPES } from "../actions/fcm";

const initialState = {
    fcms: [],
    metaFcm: {}
}

export const fcm = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.FCM_FETCH_ALL:
            return {
                ...state,
                fcms: [...action.payload]
            }
        case ACTION_TYPES.FCM_CREATE:
            return {
                ...state,
                fcms: [...state.fcms, action.payload]
            }
        case ACTION_TYPES.FCM_UPDATE:
            return {
                ...state,
                fcms: state.fcms.map(x => x.id === action.payload.id ? action.payload : x)
            }
        case ACTION_TYPES.FCM_DELETE:
            return {
                ...state,
                fcms:state.fcms.filter(x => x.id !== action.payload)
            }
        case ACTION_TYPES.FCM_PAGINATION:
            
            return {
                ...state,
                fcms: [...action.payload.fcms],
                metaFcm: action.payload.meta
            }
        default:
            return state;
    }
}